import type { SchoolTestDomain } from '@mathflat/domain/@entities/(Content)/SchoolTest/domain'
import type { RegionDomain } from '@mathflat/domain/@entities/Region/domain'
import type { SchoolType } from '@mathflat/domain/@entities/SchoolSystem/schema'
import { makeAutoObservable } from 'mobx'

import type { RegionTreeNode } from '@/modules/region/interfaces/RegionTreeNode.interface'

export class SchoolTreeNode implements RegionTreeNode {
  private _code: string
  private _name: string
  private _type: SchoolType
  private _regionCode: string
  private _provideTypes: SchoolTestDomain.ProvideType[] = []
  private _securingTypes: common.SecuringType[] = []
  private _children: RegionTreeNode[] = []
  private _sidoName: string | null = null
  private _sigunguName: string | null = null
  private _sidoCode: string | null = null
  private _sigunguCode: string | null = null

  get id(): string {
    return `${this._regionCode}_${this._code}`
  }

  get schoolCode(): string {
    return this._code
  }

  get sido(): string | null {
    return this._sidoName
  }

  get sidoCode(): string | null {
    return this._sidoCode
  }

  get sigunguCode(): string | null {
    return this._sigunguCode
  }

  get sigungu(): string | null {
    return this._sigunguName
  }

  get name(): string {
    return this._name
  }

  get children(): RegionTreeNode[] | null {
    return [...this._children]
  }

  get type(): SchoolType {
    return this._type
  }

  get securingTypes() {
    return this._securingTypes
  }

  get isAssistPaperScanner() {
    // 기출스캐너로 유도 가능한 케이스
    return (
      this._provideTypes.length === 0 ||
      this._provideTypes.includes('PDF_ONLY') ||
      this._provideTypes.includes('NONE')
    )
  }
  constructor(
    school: RegionDomain.SchoolByRegion &
      Partial<{
        sidoName: RegionDomain.Region['sidoName']
        sigunguName: RegionDomain.Region['sigunguName']
        sidoCode: RegionDomain.Region['code']
        sigunguCode: RegionDomain.Region['code']
      }>,
  ) {
    makeAutoObservable(this)

    this._code = school.code
    this._name = school.name
    this._type = school.type
    this._regionCode = school.regionCode
    this._provideTypes = school.provideTypes
    this._securingTypes = school.securingTypes
    if (school.sidoName) {
      this._sidoName = school.sidoName
    }
    if (school.sigunguName) {
      this._sigunguName = school.sigunguName
    }
    if (school.sidoCode) {
      this._sidoCode = school.sidoCode
    }
    if (school.sigunguCode) {
      this._sigunguCode = school.sigunguCode
    }
  }

  setChildren() {
    // 학교 하위는 없으므로 setChildren을 할 일 이 없음 = 내부 로직 삭제
  }
}
